import { memo } from 'react'
import { Text } from 'common-components'
import { CrownIcon } from 'containers/SubSidebar/styled'
import { COLORS } from 'consts/colors'
import { THUNDER_ICON } from 'consts/mediaUrls'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import RefillButton from 'components/RefillButton'
import Tooltip from 'components/Tooltip'
import { useAvatarGenerate } from './useAvatarGenerate'
import * as Styled from './styled'

const GenerateFooter: React.FC = () => {
  const {
    variant,
    insufficientCredits,
    isRegenerating,
    isDisabled,
    isLoading,
    generateTooltipText,
    isTooltipVisible,
    displayCost,
    isApproximateCost,
    onGenerate,
    onUpgrade,
    refillRef
  } = useAvatarGenerate()

  // A credits-variant user who is out of credits — or whose balance can't cover
  // the estimated cost — keeps the credits layout (cost badge + refill link) but
  // the main button becomes the premium/upgrade button.
  const isPremium = variant === 'premium' || insufficientCredits
  const isCredits = variant === 'credits'

  const actionLabel = isRegenerating
    ? translate(T.RE_GENERATE)
    : translate(T.GENERATE_LABEL)

  return (
    <Styled.Footer>
      <Tooltip
        tooltipText={isTooltipVisible ? generateTooltipText : ''}
        isVisible={isTooltipVisible}
        showOnMobileTap
      >
        <Styled.GenerateButtonWrapper>
          <Styled.GenerateButton
            isDisabled={isDisabled}
            $isPremium={isPremium}
            onClick={isPremium ? onUpgrade : onGenerate}
          >
            {isPremium && <CrownIcon />}
            <Styled.SpinningLoaderWrapper
              size={16}
              loaderColor={COLORS.white}
              $isVisible={isLoading}
            />
            <Text type="h2" color="white" fontWeight="600">
              {variant === 'free-trial'
                ? `${actionLabel} ${translate(T.FREE_TRIAL_LABEL)}`
                : actionLabel}
            </Text>
            {variant === 'free-trial' && <Styled.GiftIcon />}
            {isCredits && (
              <Styled.CreditsBadge>
                <Styled.ThunderIcon src={THUNDER_ICON} alt="credits" />
                {isApproximateCost ? `~${displayCost}` : displayCost}
              </Styled.CreditsBadge>
            )}
          </Styled.GenerateButton>
        </Styled.GenerateButtonWrapper>
      </Tooltip>

      {isCredits ? (
        <RefillButton referer={refillRef} />
      ) : (
        <Styled.UpgradeHint>
          <Styled.UpgradeHintText>
            {translate(T.NEED_LONGER_VIDEO_LABEL)}
          </Styled.UpgradeHintText>
          <Styled.UpgradeLink onClick={onUpgrade}>
            {translate(T.UPGRADE)}
          </Styled.UpgradeLink>
        </Styled.UpgradeHint>
      )}
    </Styled.Footer>
  )
}

export default memo(GenerateFooter)
